interface SentryUser {
    id: string
    email: string
}

interface SentryUserContext {
    user: SentryUser | null
    orgId?: string
}

interface ResolveSentryUserContextParams {
    user?: SentryUser
    orgId?: string
}

export function resolveSentryUserContext({
    user,
    orgId,
}: ResolveSentryUserContextParams): SentryUserContext {
    if (!user?.id || !user?.email) return { user: null }
    return { user: { id: user.id, email: user.email }, orgId }
}
